
<template>
    <span
        @click="hidden = !hidden"
        class="tooltip"
        v-tooltip.bottom.start.hover="vueTooltipSettings"
        v-click-away="hideTooltip"
    >
        <slot name="icon" />
        <span v-if="label" class="tooltip__label">{{ label }}</span>
    </span>
</template>

<script>

export default {
    name: 'TooltipElement',
    components: {
    },
    props: {
        label: String,
        content: {
            type: String,
        },
    },

    computed: {
        vueTooltipSettings() {

            const settings = {
                delay: 0,
                offset: 0,
                content: this.content,
                visible: !this.hidden
            };

            return settings;
        }
    },
    data() {
        return {
            hidden: true
        }
    },
    mounted() {

    },
    methods: {
        hideTooltip() {
            this.hidden = true;
        }
    }
}
</script>
